<template>
	<div class="comp">
		<el-dialog :title="'支付前批量删除'" :visible.sync="dialogState" width="1000px" top="3vh">
			<div style="max-height:500px;overflow-y: scroll;margin-left:30px;margin-top:10px;" v-if="list.length>0">
				<div v-for="(item,index) in list" :key="index">
					<div class="label">{{detail.plans[index].planName}}</div>
					<el-table class="table" :data="item" :ref="'plan'+index" style="width: 100%" @selection-change="handleSelectionChange(arguments[0],index)">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="goodsName" label="名称" >
						</el-table-column>
						<el-table-column prop="skuValue" label="规格" width="220">
						</el-table-column>
						<el-table-column prop="num" label="数量" width="80">
						</el-table-column>
						<el-table-column prop="price" label="单价" width="100">
						</el-table-column>
						<el-table-column prop="unit" label="小计" width="120">
							<template slot-scope="props">
								{{$public.getSubtotal(props.row)}}
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div slot="footer" style="text-align: center;margin-top:20px;padding-bottom:30px;">
				<el-button type="danger" @click="submit">删除选中</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				detail:{},
				list:[],
				selectionList:[],
			}
		},
		props:{
			ymqcDetail:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			dialogState(n){
				this.$emit('submit',n)
			}
		},
		mounted() {
			this.detail = JSON.parse(JSON.stringify(this.ymqcDetail))
			for(let i=0;i<this.detail.plans.length;i++){
				let list = []
				for(let a=0;a<this.detail.plans[i].planGoods.length;a++){
					if(this.detail.plans[i].planGoods[a].goodsType===1){
						list.push(this.detail.plans[i].planGoods[a])
					}
				}
				this.list.push(list)
			}
			this.$nextTick(()=>{
				for(let i=0;i<this.list.length;i++){
					for(let a=0;a<this.list[i].length;a++){
						this.$refs['plan'+i][0].toggleRowSelection(this.list[i][a],true)
					}
				}
			})
		},
		methods: {
			handleSelectionChange(selection,type){
				this['plan'+type]=selection;
				this.selectionList[type] = selection;
			},
			submit(){
				let num = 0;
				for(let i=0;i<this.selectionList.length;i++){
					num = num + this.selectionList[i].length;
				}
				if(num===0){
					this.$message({
						message: '请选择要删除的商品',
						type: 'error'
					});
					return ;
				}
				let replaceItemsIdsList = []
				for(let i=0;i<this.selectionList.length;i++){
					for(let a=0;a<this.selectionList[i].length;a++){
						let id = this.selectionList[i][a].itemsId;
						replaceItemsIdsList.push(id)
					}
				}
				let params = replaceItemsIdsList
				console.log(params)
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/MedicalPackage/RemoveGoodsMany', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('submit')
						}
					})
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.label{
			font-size: 14px;font-weight: bold;padding:20px 0 1px;
		}
		::v-deep.el-dialog__body{
			padding-top:10px;
		}
	}
</style>
